import Card from 'components/Card'
import Dialog from 'components/Dialog'
import Loading from 'components/Loading'
import constants from 'constants'
// import moment from 'moment'
import { format } from 'date-fns'
import PropTypes from 'prop-types'
import React from 'react'
import { commonFunctions } from 'utils/CommonFunctions'
import {
  DraftPlan,
  FinalAssessment,
  FinalAssessmentAgreed,
  FinalCounsellorAssessment,
  InterimAssessment, InterimCounsellorAssessment,
  SubmittedPlan,
  UploadPlan,
} from './components/Progress'

const styles = Object.assign(
  {},
  require('./PartnerPlan.scss'),
  require('components/Table/Table.scss'),
  { columns: require('./columns.scss') },
)

class PartnerPlanView extends React.Component {
    static propTypes = {
      currentUser: PropTypes.object,
      editPartnerPlan: PropTypes.func.isRequired,
      openPartnerPlanCommentForm: PropTypes.func.isRequired,
      openPartnerPlanForm: PropTypes.func.isRequired,
      openPartnerPlanNoteForm: PropTypes.func.isRequired,
      partnerPlan: PropTypes.object,
      selectedPartner: PropTypes.object,
      selectedPlan: PropTypes.object.isRequired,
    }
    static defaultProps = {
      currentUser: null,
      partnerPlan: [],
      selectedPartner: null,
    }
    constructor(props) {
      super(props)
      this.state = {
        submitPlanDialog: false,
        // agreePlanDialog: false,
        // submit: false,
      }
    }

    componentDidMount() {
      /* if (this.props.partnerPlan.partnerPlan.planStatus === constants.PARTNERPLAN.STATUS.AGREED) {
        // move to next stage
        this._updatePlan(constants.PARTNERPLAN.STATUS.INTERIM_ASSESSMENT)
      } */
    }

    _updatePlan = (planStatus) => {
      const {
        partnerPlan, selectedPlan, currentUser,
      } = this.props

      const formData = {
        employee_id: selectedPlan.EmployeeId,
        loginname: '', // loginname is stored on the webapi server session
        year: (partnerPlan.partnerPlan.year ? partnerPlan.partnerPlan.year : ''),
        interimCounsellee: (partnerPlan.partnerPlan.interimCounsellee ? partnerPlan.partnerPlan.interimCounsellee : ''),
        interimCounselleeComments: (partnerPlan.partnerPlan.interimCounselleeComments ? partnerPlan.partnerPlan.interimCounselleeComments : ''),
        interimCounsellor: (partnerPlan.partnerPlan.interimCounsellor ? partnerPlan.partnerPlan.interimCounsellor : ''),
        interimCounsellorComments: (partnerPlan.partnerPlan.interimCounsellorComments ? partnerPlan.partnerPlan.interimCounsellorComments : ''),
        interimAgreedDate: (partnerPlan.partnerPlan.interimAgreedDate ? partnerPlan.partnerPlan.interimAgreedDate : ''),
        finalCounselleeAssessment: (partnerPlan.partnerPlan.finalCounselleeAssessment ? partnerPlan.partnerPlan.finalCounselleeAssessment : ''),
        finalCounselleeComments: (partnerPlan.partnerPlan.finalCounselleeComments ? partnerPlan.partnerPlan.finalCounselleeComments : ''),
        finalCounsellorAssessment: (partnerPlan.partnerPlan.finalCounsellorAssessment ? partnerPlan.partnerPlan.finalCounsellorAssessment : ''),
        finalCounsellorComments: (partnerPlan.partnerPlan.finalCounsellorComments ? partnerPlan.partnerPlan.finalCounsellorComments : ''),
        finalAgreedDate: (partnerPlan.partnerPlan.finalAgreedDate ? partnerPlan.partnerPlan.finalAgreedDate : ''),
        planStatus,
        /* lastmodifiedby: (currentUser.IsAdmin ? constants.PARTNERPLAN.MODIFIED_BY_ADMIN : commonFunctions.iff(
          (currentUser.GivenName && currentUser.Surname),
          `${currentUser.GivenName} ${currentUser.Surname}`, currentUser.DisplayName,
        )), */
        lastModifiedBy: (commonFunctions.isAdminPortal() ? constants.PARTNERPLAN.MODIFIED_BY_ADMIN : commonFunctions.iff(
          (this.props.currentUser.GivenName && this.props.currentUser.Surname),
          `${this.props.currentUser.GivenName} ${this.props.currentUser.Surname}`, this.props.currentUser.DisplayName,
        )),
        /* planAgreedDate: (partnerPlan.partnerPlan.planStatus === constants.PARTNERPLAN.STATUS.SUBMITTED ?
          `${moment(new Date()).format()}` : partnerPlan.partnerPlan.planAgreedDate),
        planSubmittedDate: (partnerPlan.partnerPlan.planStatus === constants.PARTNERPLAN.STATUS.UPLOADED ?
          `${moment(new Date()).format()}` : partnerPlan.partnerPlan.planSubmittedDate),
        planUploadedDate: (partnerPlan.partnerPlan.planUploadedDate ? partnerPlan.partnerPlan.planUploadedDate : ''), */
        planAgreedDate: (partnerPlan.partnerPlan.planStatus === constants.PARTNERPLAN.STATUS.SUBMITTED ?
          `${format(new Date(), constants.DATE_FORMAT.STANDARD_ISO)}` : partnerPlan.partnerPlan.planAgreedDate),
        planSubmittedDate: (partnerPlan.partnerPlan.planStatus === constants.PARTNERPLAN.STATUS.UPLOADED ?
          `${format(new Date(), constants.DATE_FORMAT.STANDARD_ISO)}` : partnerPlan.partnerPlan.planSubmittedDate),
        planUploadedDate: (partnerPlan.partnerPlan.planUploadedDate ? partnerPlan.partnerPlan.planUploadedDate : ''),
        // notification requirement
        cpEmail: (partnerPlan.partnerPlan.cpEmail ? partnerPlan.partnerPlan.cpEmail : ''),
        mlEmail: (partnerPlan.partnerPlan.mlEmail ? partnerPlan.partnerPlan.mlEmail : ''),
        blEmail: (partnerPlan.partnerPlan.blEmail ? partnerPlan.partnerPlan.blEmail : ''),
        cilEmail: (partnerPlan.partnerPlan.cilEmail ? partnerPlan.partnerPlan.cilEmail : ''),
        bucooEmail: (partnerPlan.partnerPlan.bucooEmail ? partnerPlan.partnerPlan.bucooEmail : ''),
        oplEmail: (partnerPlan.partnerPlan.oplEmail ? partnerPlan.partnerPlan.oplEmail : ''),
        olEmail: (partnerPlan.partnerPlan.olEmail ? partnerPlan.partnerPlan.olEmail : ''),
        adminComments: (partnerPlan.partnerPlan.adminComments ? partnerPlan.partnerPlan.adminComments : ''),
      }
      if (formData.employee_id && formData.year && formData.planStatus) {
        formData.loggedin_employee_id = currentUser.EmployeeId
        this.props.editPartnerPlan(formData, '', selectedPlan.Role, true)
      } else {
        // console.warn('Unable to save partner plan: empid[', formData.employee_id, '], year[', formData.year, '], status[', formData.planStatus, ']')
      }
    }

    _openDialog = () => {
      const { partnerPlan } = this.props
      if (partnerPlan.partnerPlan.planStatus === constants.PARTNERPLAN.STATUS.UPLOADED) {
        this.setState({ submitPlanDialog: true })
      }
      // if (partnerPlan.partnerPlan.planStatus === constants.PARTNERPLAN.STATUS.SUBMITTED) {
      //   this.setState({ agreePlanDialog: true })
      // }
    }

    _closeDialog = () => {
      this.setState({ submitPlanDialog: false })
      // this.setState({ agreePlanDialog: false })
    }

    _submitDialog = () => {
      this.setState({
        submitPlanDialog: false,
        // agreePlanDialog: false,
        // submit: true,
      })
      const { partnerPlan } = this.props
      if (partnerPlan.partnerPlan.planStatus === constants.PARTNERPLAN.STATUS.UPLOADED) {
        this._updatePlan(constants.PARTNERPLAN.STATUS.SUBMITTED)
      }
      // if (partnerPlan.partnerPlan.planStatus === constants.PARTNERPLAN.STATUS.SUBMITTED) {
      //   this._updatePlan(constants.PARTNERPLAN.STATUS.AGREED)
      // }
    }

    _handleUpload = () => {
      this.props.openPartnerPlanForm(constants.PARTNERPLAN.FORMS.DRAFT)
    }

    _handleAgreePlan = () => {
      this.props.openPartnerPlanForm(constants.PARTNERPLAN.FORMS.SUBMITTED)
    }

    _handleInterimSelfAssessment = () => {
      this.props.openPartnerPlanForm(constants.PARTNERPLAN.FORMS.INTERIM)
    }

    _handleInterimCounsellorAssessment = () => {
      this.props.openPartnerPlanForm(constants.PARTNERPLAN.FORMS.INTERIM_COUNSELLOR)
    }

    _handleFinalSelfAssessment = () => {
      this.props.openPartnerPlanForm(constants.PARTNERPLAN.FORMS.FINAL)
    }

    _handleFinalCounsellorAssessment = () => {
      this.props.openPartnerPlanForm(constants.PARTNERPLAN.FORMS.FINAL_COUNSELLOR)
    }

    _handleInterimSelfAssessmentNotes = () => {
      this.props.openPartnerPlanNoteForm(constants.PARTNERPLAN.NOTES_HEADER.INTERIM_PARTNER)
    }

    _handleInterimCounsellorAssessmentNotes = () => {
      this.props.openPartnerPlanNoteForm(constants.PARTNERPLAN.NOTES_HEADER.INTERIM_COUNSELLOR)
    }

    _handleFinalSelfAssessmentNotes = () => {
      this.props.openPartnerPlanNoteForm(constants.PARTNERPLAN.NOTES_HEADER.FINAL_PARTNER)
    }

    _handleFinalCounsellorAssessmentNotes = () => {
      this.props.openPartnerPlanNoteForm(constants.PARTNERPLAN.NOTES_HEADER.FINAL_COUNSELLOR)
    }

    render() {
      const confirmPlanSubmitDialogProps = {
        actions: [
          { label: 'CANCEL', onClick: this._closeDialog },
          { label: 'CONFIRM', onClick: this._submitDialog },
        ],
        title: 'Submit plan',
        active: this.state.submitPlanDialog,
        onClose: this._closeDialog,
      }
      const agreePlanDialogProps = {
        actions: [
          { label: 'CANCEL', onClick: this._closeDialog },
          { label: 'AGREE', onClick: this._submitDialog },
        ],
        title: 'Agree Partner plan',
        active: this.state.agreePlanDialog,
        onClose: this._closeDialog,
      }
      const { partnerPlan, selectedPlan } = this.props
      if (partnerPlan.isFetching) {
        return (<Loading pageLoading />)
      }
      return (
        <div className={styles.content}>
          <Card noPadding>
            {partnerPlan.partnerPlan.planStatus === constants.PARTNERPLAN.STATUS.DRAFT &&
              <DraftPlan
                currentUser={this.props.currentUser}
                handleUpload={this._handleUpload}
                partnerPlan={partnerPlan}
                selectedPlan={selectedPlan}
              />
            }
            {partnerPlan.partnerPlan.planStatus === constants.PARTNERPLAN.STATUS.UPLOADED &&
              <UploadPlan
                currentUser={this.props.currentUser}
                handleOpenDialog={this._openDialog}
                handleUpload={this._handleUpload}
                partnerPlan={partnerPlan}
                selectedPlan={selectedPlan}
              />}
            {partnerPlan.partnerPlan.planStatus === constants.PARTNERPLAN.STATUS.SUBMITTED &&
              <SubmittedPlan
                currentUser={this.props.currentUser}
                handleAgreePlan={this._handleAgreePlan}
                handleUpload={this._handleUpload}
                partnerPlan={partnerPlan}
                selectedPlan={selectedPlan}
              />
            }
            {(partnerPlan.partnerPlan.planStatus === constants.PARTNERPLAN.STATUS.INTERIM_ASSESSMENT ||
              partnerPlan.partnerPlan.planStatus === constants.PARTNERPLAN.STATUS.AGREED) &&
              <InterimAssessment
                handleInterimSelfAssessment={this._handleInterimSelfAssessment}
                partnerPlan={partnerPlan}
                selectedPlan={selectedPlan}
              />
            }
            {partnerPlan.partnerPlan.planStatus === constants.PARTNERPLAN.STATUS.INTERIM_ASSESSMENT_SUBMITTED &&
              <InterimCounsellorAssessment
                handleInterimCounsellorAssessment={this._handleInterimCounsellorAssessment}
                handleInterimSelfAssessment={this._handleInterimSelfAssessment}
                handleInterimSelfAssessmentNotes={this._handleInterimSelfAssessmentNotes}
                partnerPlan={partnerPlan}
                selectedPlan={selectedPlan}
              />
            }
            {(partnerPlan.partnerPlan.planStatus === constants.PARTNERPLAN.STATUS.INTERIM_ASSESSMENT_AGREED ||
              partnerPlan.partnerPlan.planStatus === constants.PARTNERPLAN.STATUS.FINAL_ASSESSMENT) &&
              <FinalAssessment
                handleFinalSelfAssessment={this._handleFinalSelfAssessment}
                handleInterimCounsellorAssessmentNotes={this._handleInterimCounsellorAssessmentNotes}
                handleInterimSelfAssessmentNotes={this._handleInterimSelfAssessmentNotes}
                partnerPlan={partnerPlan}
                selectedPlan={selectedPlan}
              />
            }
            {partnerPlan.partnerPlan.planStatus === constants.PARTNERPLAN.STATUS.FINAL_ASSESSMENT_SUBMITTED &&
              <FinalCounsellorAssessment
                handleFinalCounsellorAssessment={this._handleFinalCounsellorAssessment}
                handleFinalSelfAssessment={this._handleFinalSelfAssessment}
                handleFinalSelfAssessmentNotes={this._handleFinalSelfAssessmentNotes}
                handleInterimCounsellorAssessmentNotes={this._handleInterimCounsellorAssessmentNotes}
                handleInterimSelfAssessmentNotes={this._handleInterimSelfAssessmentNotes}
                partnerPlan={partnerPlan}
                selectedPlan={selectedPlan}
              />
            }
            {partnerPlan.partnerPlan.planStatus === constants.PARTNERPLAN.STATUS.FINAL_ASSESSMENT_AGREED &&
              <FinalAssessmentAgreed
                handleFinalCounsellorAssessmentNotes={this._handleFinalCounsellorAssessmentNotes}
                handleFinalSelfAssessmentNotes={this._handleFinalSelfAssessmentNotes}
                handleInterimCounsellorAssessmentNotes={this._handleInterimCounsellorAssessmentNotes}
                handleInterimSelfAssessmentNotes={this._handleInterimSelfAssessmentNotes}
                partnerPlan={partnerPlan}
                selectedPlan={selectedPlan}
              />
            }
            {/* OUT OF SCOPE </div><CardFooter>
              <div className={classnames(styles.buttonContainer, styles.flexDirection)}>
                <div className={styles.buttonElement1}>
                  <Button className={classnames(styles.buttonAction, styles.buttonLeft, styles.buttonBorder)} onClick={this._handleServiceAreaLeaderComments} type="flat" >
                Service Area Lead/Offering Portfolio Lead Feedback
              </Button>
                </div>
              </div>
          </CardFooter> */}
          </Card>
          <Dialog {...confirmPlanSubmitDialogProps}>Are you sure you want to submit your Partner plan?</Dialog>
          <Dialog {...agreePlanDialogProps}>Once you agree, all plan details for this step can not be edited.</Dialog>
        </div>
      )
    }
}

export default PartnerPlanView



// WEBPACK FOOTER //
// ./src/views/PartnerPlans/PartnerPlan.js